import { handleOpenTriggerClick } from "./handleOpenTriggerClick";
import { handleCloseTriggerClick } from "./handleCloseTriggerClick";
import { handleTriggerFocus } from "./handleTriggerFocus";

export const initializeModal = (modal) => {
  if (!modal) {
    console.error("Element required for initializeModal is not found.");
    return;
  }

  const openTriggers = document.querySelectorAll(`[data-modal-open="${modal.id}"]`);
  const closeTriggers = modal.querySelectorAll("[data-modal-close]");

  if (openTriggers.length === 0 || closeTriggers.length === 0) {
    console.error("Elements required for modal trigger are not found.");
    return;
  }

  openTriggers.forEach((trigger) => {
    trigger.addEventListener(
      "click",
      (event) => handleOpenTriggerClick(event, modal, trigger),
      false
    );
    trigger.addEventListener("mousedown", handleTriggerFocus, false);
    trigger.addEventListener("keydown", handleTriggerFocus, false);
  });

  closeTriggers.forEach((trigger) => {
    trigger.addEventListener(
      "click",
      (event) => handleCloseTriggerClick(event, modal),
      false
    );
  });
};
